<template>
    <div :class="{ constrain: showSidebar }">
        <!-- <div class='nav-bg' /> -->
        <Navigation v-model="showSidebar" v-if="showNav" />

        <div :class="{ main: showNav }" id="main">
            <!-- <transition name="opacity"> -->
            <router-view />
            <!-- </transition> -->
        </div>

        <Sidebar v-if="showSidebar" v-model="showSidebar" />
        <LogInModule :show="showLogInModal" />
        <Dialog />
        <NotificationModule />
        <ScrollToTop />
    </div>
</template>

<script>
import Navigation from './components/navigation/Navigation';
import Sidebar from './components/navigation/Sidebar';
import LogInModule from './shared/loginmodule/LogInModule';
import NotificationModule from './components/smart/NotificationModule/NotificationModule';
import ScrollToTop from './components/miscellaneous/ScrollToTop';

// Utils
import AuthService from '~/services/AuthService';
import LogService from '~/services/LogService';
import UniversityService from '~/services/UniversityService';
import MessageService from '~/services/MessageService';
import IntercomService from '~/services/IntercomService';
import BackgroundProcessService from '~/services/BackgroundProcessesService';
import { redirectToHttps } from '~/utils/urlUtils';

export default {
    components: {
        Navigation,
        Sidebar,
        LogInModule,
        NotificationModule,
        ScrollToTop,
    },
    data: () => ({
        showSidebar: false,
        blacklist: ['/login', '/recover-password', '/redirect'],
    }),
    computed: {
        showNav() {
            return (
                this.blacklist.filter(el => el === this.$route.path).length ===
                0
            );
        },
        showLogInModal() {
            return (
                this.$interfaces.logInModule.isOpen() &&
                !this.$interfaces.logInModule.getDisabledPopup()
            );
        },
    },
    created() {
        // Redirect to production
        if (process.env.NODE_ENV === 'production') {
            redirectToHttps();
        }
    },
    mounted() {
        // Change document title to university title
        UniversityService.initialize();

        // Initialize user-identity for logging
        if (AuthService.isAuthenticated()) {
            this.$interfaces.logInModule.setIsLoggedIn(true);
        } else {
            LogService.resetIdentity(); // Uses an anonymous user
        }

        // Initialize logIn popup after X amount of seconds
        BackgroundProcessService.scheduleLogInPopup();
        this.$interfaces.logInModule.setForcedLogin();
    },
};
</script>

<style>
.main {
    margin-top: 70px;
}

@media only screen and (max-width: 1000px) {
    .main {
        margin-top: 60px;
    }
}
</style>
